// @flow
import React, { useEffect, useState } from 'react';
import {Row, Col, Card, Modal, Button} from 'react-bootstrap';
import {useDispatch, useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';
import EventCoachTableView from "../../components/EventCoachTableView"

//actions
import {filterBookings, listBookings} from '../../redux/actions';

// components
import PageTitle from '../../components/PageTitle';
import * as moment from 'moment'
import Loader from "../../components/Loader";
import HyperDatepicker from "../../components/Datepicker";
import { APICore } from '../../helpers/api/apiCore';
import DateTimeFormatter from "../../components/DateTimeFormatter";
import CurrencyFormatter from "../../components/CurrencyFormatter";
import ModalEditCoachBooking from "../../components/ModalEditCoachBooking";


const Bookings = (): React$Element<React$FragmentType> => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [searchText, setSearchText] = useState("")
    const [status, setStatus] = useState("1");
    const [eventCoach, setEventCoach] = useState(null);
    const [signInModal, setSignInModal] = useState(false);
    const [eventDateFrom, setEventDateFrom] = useState("")
    const [eventDateTo, setEventDateTo] = useState("")
    let currentPathname = window.location.pathname

    useEffect(() => {
        dispatch(listBookings());
    }, [dispatch]);

    const { loading, event_coaches, total_pages } = useSelector((state) => ({
        loading: state.BookingReducer.loading,
        event_coaches: state.BookingReducer.event_coaches,
        error: state.BookingReducer.error,
        total_pages: state.BookingReducer.total_pages,
    }));

    const toggleSignIn = (event_coach) => {
        setEventCoach(event_coach)
        setSignInModal(!signInModal);
    };


    const handleSearch = () => {

        let filter_object = {}

        if(searchText !== ""){
            filter_object["event_name_cont"] = searchText
        }

        if(status !== ""){
            filter_object["status_eq"] = status
        }

        if(eventDateFrom !== ""){
            filter_object["event_start_date_gteq"] = moment(eventDateFrom).format('DD.MM.YYYY')
        }

        if(eventDateTo !== ""){
            filter_object["event_start_date_lteq"] = moment(eventDateTo).format('DD.MM.YYYY') + " 23:59:59"
        }

        dispatch(filterBookings(filter_object));


    }

    const getPageTitle = () => {
        return(<>
            { eventCoach?.event?.name }
        </>)
    }


    return (
        <>
            <PageTitle
                title={t("coach_bookings")}
            />

            <Row>
                <Col>
                    <Card.Header>
                        <h4 className="my-1">{t("search")}</h4>
                    </Card.Header>
                    <Card className="d-block">
                        <Card.Body>

                            <div className="row">
                                <div className="col-md-6">

                                    <div>
                                        <input type="text" className="form-control"
                                               onChange={event => setSearchText(event.target.value)}
                                               placeholder={t("search")}/>
                                        <small className="text-muted">{t("invoice_search_hint")}</small>
                                    </div>

                                </div>

                                <div className="col-md-3">
                                    <select className="form-select"
                                            onChange={event => {
                                                setStatus(event.target.value)
                                            }}
                                    >
                                        <option value="">{t("choose_status_filter")}</option>
                                        <option value="0">{t("pending")}</option>
                                        <option value="1" selected>{t("accepted")}</option>
                                        <option value="2">{t("denied")}</option>
                                    </select>
                                </div>

                                <div className="col-md-3">
                                    <a href="/bookings" className="mr-2"
                                       style={{marginRight: "15px"}}>{t("show_all")}</a>
                                    <button className="btn btn-primary ml-2"
                                            onClick={handleSearch}>{t("search")}</button>
                                </div>
                            </div>

                            <div className="row mt-3">

                                <div className="col-md-3">
                                    <label className="mb-1">{t("start_date_from")}</label>
                                    <HyperDatepicker
                                        value={eventDateFrom}
                                        inputClass="form-control-light"
                                        onChange={(date) => {
                                            setEventDateFrom(date);
                                        }}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="mb-1">{t("start_date_to")}</label>
                                    <HyperDatepicker
                                        value={eventDateTo}
                                        inputClass="form-control-light"
                                        onChange={(date) => {
                                            setEventDateTo(date);
                                        }}
                                    />
                                </div>

                            </div>


                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <ModalEditCoachBooking dashboard={false}  onHide={() => { setSignInModal(false) }} signInModal={signInModal} eventCoach={eventCoach} getPageTitle={getPageTitle()} />

            <EventCoachTableView loading={loading} event_coaches={event_coaches} toggleSignIn={toggleSignIn}  total_pages={total_pages}/>
        </>
    );
}
;


export default Bookings;
